import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import "./AllAssignmentSchool.css";
import { useEffect, useState } from "react";
import axios from "axios";

const AllAssignmentSchool = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [allAssignment, setAllAssignment] = useState([]);
  const [niosClass, setNiosClass] = useState([]);
  const [niosClassId, setNiosClassId] = useState("");
  const [allSubjects, setAllSubjects] = useState([]);
  const [allSubjectsId, setAllSubjectsId] = useState();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        setNiosClass(resp.data);
      })
      .catch((error) => {
        console.error("Error fetching classes:", error);
      });
  }, []);

  useEffect(() => {
    if (niosClassId) {
      axios
        .get(`${API_BASE_URL}/niosSubjects?classId=${niosClassId}`)
        .then((result) => {
          setAllSubjects(result.data);
        })
        .catch((error) => {
          console.error("Error fetching subjects:", error);
        });
    }
  }, [niosClassId]);

  useEffect(() => {
    axios
      .get(
        `${API_BASE_URL}/niosAssignment?${
          allSubjectsId ? `subjectId=${allSubjectsId}` : ""
        }`
      )
      .then((response) => {
        console.log(response.data);
        setAllAssignment(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [allSubjectsId, niosClassId]);

  const handleEdit = (id) => {
    navigate(`/student-assignment/edit-school/${id}`);
  };
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this assignment?"
    );
    if (confirmDelete) {
      axios
        .delete(`${API_BASE_URL}/admin/niosAssignment/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then(() => {
          alert("Assignment deleted successfully!");
          setAllAssignment((prevAssignments) =>
            prevAssignments.filter((assignment) => assignment._id !== id)
          );
        })
        .catch((error) => {
          console.error("Error deleting assignment:", error);
          alert("Failed to delete the assignment. Please try again.");
        });
    }
  };

  return (
    <>
      <div id="school-all-assignments-table">
        <div className="school-all-ass-heading-or-btns">
          <h4>School Assignments</h4>
          <div className="school-all-ass-nav-btns">
            <button onClick={() => navigate("/student-assignment/school")}>
              School Assignment
            </button>
            <button>School All Assignments</button>
          </div>
        </div>
        <div>
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Class</b>
            </label>
            <select
              className="p-2"
              value={niosClassId}
              onChange={(e) => setNiosClassId(e.target.value)}
              required
            >
              <option value="">--Select Class--</option>
              {niosClass.map((item, idx) => (
                <option value={item._id} key={idx}>
                  {item.className}
                </option>
              ))}
            </select>
          </div>
          <div className="ass-school-input-group">
            <label className="my-2">
              <b>Subject</b>
            </label>
            <select
              className="p-2"
              value={allSubjectsId}
              onChange={(e) => setAllSubjectsId(e.target.value)}
              required
            >
              <option value="">--Select Subject--</option>
              {allSubjects.map((item, idx) => (
                <option value={item._id} key={idx}>
                  {item.subjectName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="school-all-assignment-inner">
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Assignment Title</th>
                <th>Assignment Pdf</th>
                <th>Language</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {allAssignment.length > 0 ? (
                allAssignment.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.assignment}</td>
                    <td>
                      <Link
                        to={`${API_BASE_URL}/uploads/${item.assignmentpdfPath}`}
                      >
                        {item.assignmentpdfPath}
                      </Link>
                    </td>
                    <td>{item.language}</td>
                    <td>
                      <span>
                        <FaEdit onClick={() => handleEdit(item._id)} />
                      </span>
                      <span>
                        <MdDelete onClick={() => handleDelete(item._id)} />
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center p-5" colSpan="5">
                    <h2>No assignment found.</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllAssignmentSchool;
